// extracted by mini-css-extract-plugin
module.exports = {"table":"Test_table__1U9P9"};